/**
 * @generated SignedSource<<16f14887ec40d480222219f3d85c1432>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RunBuildParametersQuery$variables = {
  locator: string;
};
export type RunBuildParametersQuery$data = {
  readonly buildParametersOfBuildType: {
    readonly property: ReadonlyArray<{
      readonly type: {
        readonly rawValue: string | null;
      } | null;
    }> | null;
  } | null;
};
export type RunBuildParametersQuery = {
  response: RunBuildParametersQuery$data;
  variables: RunBuildParametersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "btLocator",
        "variableName": "locator"
      }
    ],
    "concreteType": "Properties",
    "kind": "LinkedField",
    "name": "buildParametersOfBuildType",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Property",
        "kind": "LinkedField",
        "name": "property",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Type",
            "kind": "LinkedField",
            "name": "type",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunBuildParametersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunBuildParametersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6b86bf2dff8ec6514d41efb8f85498b",
    "id": null,
    "metadata": {},
    "name": "RunBuildParametersQuery",
    "operationKind": "query",
    "text": "query RunBuildParametersQuery(\n  $locator: String!\n) {\n  buildParametersOfBuildType(btLocator: $locator) {\n    property {\n      type {\n        rawValue\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94200f34446c72d2266592e97c11f817";

export default node;
